module.exports = __webpack_public_path__ + "img/cancel.391c0f3b.png";